import { InterstitialContent } from '../content.types';
import { dataFor } from '../data';
import { useLanguage } from './use-content';

export interface UseInterstitialContentResult {
  content?: InterstitialContent;
  isLoading: boolean;
}

export function useInterstitialContent(
  id?: string,
): UseInterstitialContentResult {
  const language = useLanguage();
  const interstitials = dataFor('interstitials', language);
  const content = id ? interstitials[id] : undefined;
  return { content, isLoading: false };
}

export function useInterstitialContentGroup(groupId?: string): {
  items: InterstitialContent[];
  isLoading: boolean;
} {
  const language = useLanguage();
  const groups = dataFor('interstitialGroups', language);
  const items = groupId ? (groups[groupId] ?? []) : [];
  return { items, isLoading: false };
}
